import { SEMANTIC_COLORS_LIST, LIGHT_BACKGROUND_COLORS } from '../../constants';
export const blockGridConfig = {
    name: 'BlockGrid',
    category: 'Zapier Sections',
    image: 'https://cdn.zappy.app/71a7c8c0547ac245aebdc925fa5eb32f.png',
    canHaveChildren: true,
    includeScrollTracking: true,
    inputs: [
        {
            name: 'maxColumns',
            type: 'number',
        },
        {
            name: 'sectionHeading',
            type: 'string',
        },
        {
            name: 'sectionHeadingSize',
            type: 'string',
            enum: ['small', 'medium', 'large'],
        },
        {
            name: 'sectionSubheading',
            type: 'string',
        },
        { name: 'ctaText', type: 'string' },
        { name: 'ctaHref', type: 'string' },
        {
            name: 'backgroundColor',
            type: 'string',
            enum: LIGHT_BACKGROUND_COLORS,
        },
        {
            name: 'ctaColor',
            type: 'string',
            enum: SEMANTIC_COLORS_LIST,
        },
    ],
};
//# sourceMappingURL=config.js.map